import { createSlice } from "@reduxjs/toolkit"

interface ProvidersState {
  specialityList: Array<any>
  selectedSpeciality: any
  providersGroupList: Array<any>
  selectedProvidersGroups: Array<any>
  providersRegionList: Array<any>
  selectedProvidersRegions: Array<any>
  providersOfficeList: Array<any>
  selectedProvidersOffices: Array<any>
  providersList: Array<any>
  selectedProviders: Array<any>
  providersMetricTabs: Array<any>
  selectedProvidersMetricTab: any
  allProviderMetrics: Array<any>
  filteredProviderMetrics: Array<any>
  selectedProviderMetrics: Array<any>
  allProviderColumns: Array<any>
  selectedProviderColumns: Array<any>
  providersData: Array<any>
  providersTableData: Array<any>
  isAllGroupSelected: Boolean
  isAllRegionSelected: Boolean
  isAllOfficeSelected: Boolean
}

const initialState: ProvidersState = {
  specialityList: [],
  selectedSpeciality: null,
  providersGroupList: [],
  selectedProvidersGroups: [],
  providersRegionList: [],
  selectedProvidersRegions: [],
  providersOfficeList: [],
  selectedProvidersOffices: [],
  providersList: [],
  selectedProviders: [],
  providersMetricTabs: [],
  selectedProvidersMetricTab: {},
  allProviderMetrics: [],
  filteredProviderMetrics: [],
  selectedProviderMetrics: [],
  allProviderColumns: [],
  selectedProviderColumns: [],
  providersData: [],
  providersTableData: [],
  isAllGroupSelected: false,
  isAllRegionSelected: false,
  isAllOfficeSelected: false,
}

const providersSlice = createSlice({
  name: "providers",
  initialState,
  reducers: {
    setSpecialityList: (state, action) => {
      state.specialityList = action.payload
    },
    setSelectedSpeciality: (state, action) => {
      state.selectedSpeciality = action.payload
    },
    setProvidersGroupList: (state, action) => {
      state.providersGroupList = action.payload
    },
    setSelectedProvidersGroups: (state, action) => {
      state.selectedProvidersGroups = action.payload
    },
    setProvidersRegionList: (state, action) => {
      state.providersRegionList = action.payload
    },
    setSelectedProvidersRegions: (state, action) => {
      state.selectedProvidersRegions = action.payload
    },
    setProvidersOfficeList: (state, action) => {
      state.providersOfficeList = action.payload
    },
    setSelectedProvidersOffices: (state, action) => {
      state.selectedProvidersOffices = action.payload
    },
    setProvidersList: (state, action) => {
      state.providersList = action.payload
    },
    setSelectedProviders: (state, action) => {
      state.selectedProviders = action.payload
    },
    setProvidersMetricTabs: (state, action) => {
      state.providersMetricTabs = action.payload
    },
    setSelectedProvidersMetricTab: (state, action) => {
      state.selectedProvidersMetricTab = action.payload
    },
    setAllProviderMetrics: (state, action) => {
      state.allProviderMetrics = action.payload
    },
    setFilteredProviderMetrics: (state, action) => {
      state.filteredProviderMetrics = action.payload
    },
    setSelectedProviderMetrics: (state, action) => {
      state.selectedProviderMetrics = action.payload
    },
    setAllProviderColumns: (state, action) => {
      state.allProviderColumns = action.payload
    },
    setSelectedProviderColumns: (state, action) => {
      state.selectedProviderColumns = action.payload
    },
    setProvidersData: (state, action) => {
      state.providersData = action.payload
    },
    setProvidersTableData: (state, action) => {
      state.providersTableData = action.payload
    },
    setIsAllGroupSelected: (state, action) => {
      state.isAllGroupSelected = action.payload
    },
    setIsAllRegionSelected: (state, action) => {
      state.isAllRegionSelected = action.payload
    },
    setIsAllOfficeSelected: (state, action) => {
      state.isAllOfficeSelected = action.payload
    },
  },
})

export default providersSlice.reducer
export const {
  setSpecialityList,
  setProvidersGroupList,
  setProvidersRegionList,
  setProvidersOfficeList,
  setProvidersList,
  setSelectedSpeciality,
  setSelectedProvidersGroups,
  setSelectedProvidersRegions,
  setSelectedProvidersOffices,
  setSelectedProviders,
  setProvidersMetricTabs,
  setSelectedProvidersMetricTab,
  setAllProviderMetrics,
  setFilteredProviderMetrics,
  setSelectedProviderMetrics,
  setAllProviderColumns,
  setSelectedProviderColumns,
  setProvidersData,
  setProvidersTableData,
  setIsAllGroupSelected,
  setIsAllRegionSelected,
  setIsAllOfficeSelected,
} = providersSlice.actions
